import React, { useContext, useState, useCallback, useEffect } from 'react'
import Card from 'atoms/Card'
import Banner from 'atoms/Banner'

import RetirementGapTable from 'layouts/authenticated/pages/newdash/components/RetirementGapTable'

import { IntakeContext } from 'context/IntakeContext'
import { apiClient } from 'utils/api/apiClient'
import { UpdatedCalcs } from 'admin/UpdatedCalcs'
import { useDashboardCalculations } from 'layouts/authenticated/pages/dashboard/hooks/useDashboardCalculations'
import { useRetirementGapCalculations } from 'layouts/authenticated/pages/dashboard/hooks/useRetirementGapCalculations'
import { usePARCOScoreCalculations } from 'layouts/authenticated/pages/dashboard/hooks/usePARCOScoreCalculations'

function RetirementGapUnlock() {
  const { intakeState } = useContext(IntakeContext)

  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])
  const [incomes, setIncomes] = useState([])
  const [expenses, setExpenses] = useState([])

  const [assetsLoaded, setAssetsLoaded] = useState(false)

  const getAccounts = useCallback(async () => {
    try {
      const {
        data: { items },
      } = await apiClient.get('api/assets')

      const foundAssets = items?.filter(({ type }) => type === 'asset') || []
      setAssets(foundAssets)

      const foundLiabilities =
        items?.filter(({ type }) => type === 'liability') || []
      setLiabilities(foundLiabilities)

      const foundDeductions =
        items?.filter(({ type }) => type === 'deduction') || []
      setDeductions(foundDeductions)

      const foundIncomes = items?.filter(({ type }) => type === 'income') || []
      setIncomes(foundIncomes)

      const foundExpenses =
        items?.filter(({ type }) => type === 'expense') || []
      setExpenses(foundExpenses)

      setAssetsLoaded(true)
    } catch (error) {
      console.error('Failed to fetch accounts', error)
      setAssetsLoaded(false)
    }
  }, [])

  useEffect(() => {
    getAccounts()
  }, [getAccounts])

  const { valueOfAssets, valueOfInvestableAssets } = UpdatedCalcs({
    assets,
    liabilities,
  })

  const { yearsTillRetirement } = useDashboardCalculations(
    deductions,
    liabilities
  )

  const {
    adjustedNetTakeHomeInRetirement,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeDifferencePARCOGap,
  } = useRetirementGapCalculations(deductions, liabilities)

  const { parcoReadinessScore4Percent } = usePARCOScoreCalculations(
    assets,
    liabilities,
    adjustedWorkingNetTakeHome,
    adjustedNetTakeHomeInRetirement,
    adjustedNetTakeHomeDifferencePARCOGap
  )

  return (
    <RetirementGapTable
      parcoScore={parcoReadinessScore4Percent}
      retirementGap={Math.abs(adjustedNetTakeHomeDifferencePARCOGap)}
      intakeState={intakeState}
      deductions={deductions}
      liabilities={liabilities}
      incomes={incomes}
      expenses={expenses}
      getAccounts={getAccounts}
    />
  )
}

export default RetirementGapUnlock
